import { Helmet } from "react-helmet-async";

const SITE = "https://www.bondpay.au/";

type Props = {
  title: string;
  description?: string;
  path?: string; 
  image?: string; 
  type?: "website" | "article";
  noindex?: boolean;
};

export default function Seo({
  title,
  description = "",
  path,
  image,
  type = "website",
  noindex = false,
}: Props) {
  const canonical = path ? `${SITE.replace(/\/$/, "")}${path}` : undefined;
  const img = image?.startsWith("http")
    ? image
    : image
    ? `${SITE.replace(/\/$/, "")}${image}`
    : undefined;

  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      {canonical && <link rel="canonical" href={canonical} />}
      {noindex && <meta name="robots" content="noindex,follow" />}


      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      {description && <meta property="og:description" content={description} />}
      {canonical && <meta property="og:url" content={canonical} />}
      {img && <meta property="og:image" content={img} />}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      {description && <meta name="twitter:description" content={description} />}
      {img && <meta name="twitter:image" content={img} />}
    </Helmet>
  );
}
